import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ISearchHit, LinkType } from '@platform/core/types';
import { useAddLinkMutation } from '@platform/state/api';
import { ErrorBanner } from '@platform/ui';
import { LINK_ORDER } from '../../tabs/related/linkOrder';
import { RelatedFinder } from '../../tabs/related/RelatedFinder';
import type { INavigatorAddProps } from './INavigatorAddProps';

/** «+ Додати зв’язок» навігатора (прототип v4): «Зв’язати центральний запис з» · пошук запису будь-якого модуля · тип зв'язку · «Додати». */
export function NavigatorAdd({ ws, centerId, exclude, onAdded }: INavigatorAddProps) {
  const { t } = useTranslation();
  const [picked, setPicked] = useState<ISearchHit | null>(null);
  const [type, setType] = useState<LinkType>('relates');
  const [add, { isLoading, error }] = useAddLinkMutation();
  const submit = () => {
    if (picked) void add({ recordId: centerId, body: { toRecordId: picked.recordId, linkType: type } }).unwrap().then(() => { setPicked(null); onAdded(); }).catch(() => undefined);
  };
  return (
    <div className="rec-nav__add">
      <span className="rec-nav__addlabel">{t('recordPage.nav.linkTo')}</span>
      <RelatedFinder ws={ws} exclude={exclude} picked={picked} onPick={setPicked} onAdvanced={() => undefined} />
      <select className="rtab-select" aria-label={t('recordPage.related.linkType')} value={type} onChange={(e) => setType(e.target.value as LinkType)}>
        {LINK_ORDER.map((x) => <option key={x} value={x}>{t(`recordPage.linkTypes.${x}`)}</option>)}
      </select>
      <button type="button" className="rtab-btn rtab-btn--primary" disabled={!picked || isLoading} onClick={submit}>{t('recordPage.nav.add')}</button>
      <ErrorBanner error={error} />
    </div>
  );
}
